import {requestUrl, requestHeaders, requestOptions} from '../../graphQLClient.js'
import Vue from 'vue';
import {isExists, isEmptyObject} from "@/helpers/check_variable_types";

const CSV = 'CSV';
const reportName = 'rawDataPartnerReport';

export default {

    getSummaryDataFromAPI({dispatch, state}, filtersData)
    {
        return new Promise(function (resolve, reject) {
            return resolve({});
        });
    },

    getReportDataFromAPI({dispatch, state}, filtersData)
    {
        let columnsData = filtersData.columns;
        let sortingData = filtersData.sorting;
        let filtersList = filtersData.reportFilters;
        let paginationData = filtersData.paginationData;

        if (
            isEmptyObject(filtersList) ||
            !filtersData.isBaseDataLoaded
        )
        {
            return new Promise(function (resolve, reject) {
                return resolve({});
            });
        }

        let requestQueryBody = {
            operationName: null,
            query: null,
            variables: {}
        };

        let filtersDeclaration = [];
        let filtersSchema = [];
        let columns = '';
        let limit = 15;

        filtersDeclaration.push('$orderByField: String!');
        filtersDeclaration.push('$orderByDirection: String!');
        filtersDeclaration.push('$paginationCursorBefore: String!');
        filtersDeclaration.push('$paginationCursorAfter: String!');

        requestQueryBody.variables.paginationCursorBefore = '';
        requestQueryBody.variables.paginationCursorAfter = '';
        requestQueryBody.variables.orderByField = 'partnerId';
        requestQueryBody.variables.orderByDirection = 'DESC';

        requestQueryBody.variables.first = null;
        requestQueryBody.variables.last = null;
        filtersDeclaration.push('$first: Int');
        filtersDeclaration.push('$last: Int');

        if (filtersList.filters.format !== undefined) {
            limit = null;
            requestQueryBody.variables.reportFormat = filters.format;
            filtersDeclaration.push('$reportFormat: ReportFormat');
            filtersSchema.push('reportFormat: $reportFormat');
        }

        if (filtersList.filters !== undefined)
        {
            if (columnsData !== undefined && columnsData.length)
            {
                let realColumns = columnsData.filter(column => column.virtualField !== true);
                realColumns = realColumns.filter(column => column.visible === true);

                let mainColumns = realColumns.filter(column => column.isMetricValue === false);
                let metricsColumns = realColumns.filter(column => column.isMetricValue === true);

                columns = mainColumns.map(column => column.field).join('\n') + ' \n partnerId';
                columns = columns + '\n' + 'metrics {' + metricsColumns.map(column => column.field).join('\n') + '\n' + 'date \n style \n ';

                columns += '\n}';
            }

            if (
                filtersList.filters.dateRange.startDateB !== null && filtersList.filters.dateRange.startDateB !== undefined &&
                filtersList.filters.dateRange.endDateB !== null && filtersList.filters.dateRange.endDateB !== undefined
            ) {
                requestQueryBody.variables.dateRangesIn = [
                    [filtersList.filters.dateRange.startDate.format("YYYY-MM-DD"), filtersList.filters.dateRange.endDate.format("YYYY-MM-DD")],
                    [filtersList.filters.dateRange.startDateB.format("YYYY-MM-DD"), filtersList.filters.dateRange.endDateB.format("YYYY-MM-DD")]
                ];
                filtersDeclaration.push('$dateRangesIn: [[String!]]');
                filtersSchema.push('dateRangesIn: $dateRangesIn');
            }
            else if (isExists(filtersList.filters.dateRange.startDate) && isExists(filtersList.filters.dateRange.endDate)) {
                requestQueryBody.variables.dateInRange = [
                    filtersList.filters.dateRange.startDate.format("YYYY-MM-DD"),
                    filtersList.filters.dateRange.endDate.format("YYYY-MM-DD")
                ];
                filtersDeclaration.push('$dateInRange: [String!]');
                filtersSchema.push('dateInRange: $dateInRange');
            }

            if (paginationData.paginationItemsLimit && (filtersList.filters.format === undefined || filtersList.filters.format != CSV)) {
                limit = paginationData.paginationItemsLimit;
            }

            if (isExists(filtersList.filters.tableTypeName) && filtersList.filters.tableTypeName.length > 0)
            {
                requestQueryBody.variables.rawTablesTypes = filtersList.filters.tableTypeName;
                filtersDeclaration.push('$rawTablesTypes: [String!]');
                filtersSchema.push('rawTablesTypesIn: $rawTablesTypes');
            }

            if (isExists(filtersList.filters.partnerId) && filtersList.filters.partnerId.length > 0) {
                requestQueryBody.variables.partnerId = filtersList.filters.partnerId;
                filtersDeclaration.push('$partnerId: [Int!]');
                filtersSchema.push('partnerIdIn: $partnerId');
            }

            if (sortingData.sortColumn !== null && sortingData.sortDirection !== null) {
                requestQueryBody.variables.orderByField = sortingData.sortColumn;
                requestQueryBody.variables.orderByDirection = sortingData.sortDirection;
            }

            if (paginationData.pagination !== null) {
                if (paginationData.pagination.direction == 'after') {
                    requestQueryBody.variables.paginationCursorAfter = paginationData.pagination.cursor;
                    requestQueryBody.variables.first = limit;
                }
                else if (paginationData.direction == 'before') {
                    requestQueryBody.variables.paginationCursorBefore = paginationData.pagination.cursor;
                    requestQueryBody.variables.last = limit;
                }
                else {
                    requestQueryBody.variables.first = limit;
                }
            }
        }

        var format = null;
        if (filtersList.filters !== undefined && filtersList.filters.format !== undefined) {
            format = filters.format;
        }

        requestQueryBody.query = getReportRequestBody(columns, filtersDeclaration, filtersSchema, format);

        let options = Object.assign({
            body: JSON.stringify(requestQueryBody),
            headers: requestHeaders
        }, requestOptions);

        return fetch(requestUrl, options).then(function (response) {
            if (format == CSV) {
                return response.blob();
            }
            else {
                return response.json();
            }
        }).then(function (data) {
            if (format == CSV) {
                return data;
            }
            else {
                if (data.errors) {
                    console.log(data.errors);
                    throw new Error('Something is broken in API');
                }

                return data.data;
            }
        }).catch(function (reason) {
            Vue.$log.warn(reason);

            Vue.prototype.$notification.setPosition('topRight')
                .setCloseStatus(true)
                .setCloseOnClick(true)
                .setCloseOnEscape(true)
                .setTimeout(false)
                .setSettings();

            Vue.prototype.$notification.showWarning('Warning!', 'Can not get data');

            return [];
        });
    },

    getReportChartsData({dispatch, state}, filters) {
    },

    setTablesTypesList({dispatch, state, commit}, value) {
        commit('setTablesTypesList', value)
    },
    setFilteredRawTablesTypesList({dispatch, state, commit}, value) {
        commit('setFilteredRawTablesTypesList', value);
        dispatch('setFilteredRawTablesTypesObjectList', value);
    },
    setFilteredRawTablesTypesObjectList({dispatch, state, rootGetters, commit}, value) {

        if (typeof value  === 'undefined') {
            commit('setFilteredRawTablesTypesObjectList', []);
            return;
        }

        let objects = value.map(function(item) {
            return {
                name: item,
            };
        });

        commit('setFilteredRawTablesTypesObjectList', objects);
    },
    getRawTablesTypes: function() {
        let requestQueryBody = {};
        requestQueryBody.operationName = null;

        requestQueryBody.query = `
                                      {
                                        rawDataPartnersTableTypes(
                                               orderBy: {sort: "name", direction: "ASC"} 
                                              ) {
                                          edges {
                                            node {
                                              name
                                            }
                                          }
                                        }
                                        
                                      }
                                     `;

        requestQueryBody.variables = null;

        let options = Object.assign({
            body: JSON.stringify(requestQueryBody),
            headers: requestHeaders
        }, requestOptions);

        return fetch(requestUrl, options).then(function(response){
            return response.json();
        }).then(function(data){
            return data.data;
        });
    },
};

function getReportRequestBody(columns, filtersDeclaration, filters, format = null) {
    let query;

    query = `query ` + reportName + `(` + filtersDeclaration.join(', ') + `
                               ){
                                  report: ` + reportName + `(first: $first,
                                    last: $last, 
                                    filters: {
                                        ` + filters.join(', ') +
        `                         }, 
                                    after: $paginationCursorAfter,
                                    before: $paginationCursorBefore,
                                    orderBy: [
                                        {sort: $orderByField, direction: $orderByDirection}
                                    ]) 
                                    {
                                      totalCount,
                                      pageInfo {
                                        hasNextPage
                                        hasPreviousPage
                                        startCursor
                                        endCursor
                                      }
                                      edges {
                                        cursor
                                        node {
                                            ` + columns + `
                                        }
                                    }
                                  }
                              }
                            `;

    // console.log('getReportRequestBody' + query);

    return query;
}




// WEBPACK FOOTER //
// ./src/store/modules/rawDataPartnersReport/actions.js